var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Exit = function Exit(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.818 6a.855.855 0 0 0-.592.233.717.717 0 0 0-.226.517V8.5a1 1 0 1 1-2 0V6.75c0-.742.307-1.445.84-1.958A2.855 2.855 0 0 1 11.817 4h6.364c.735 0 1.448.28 1.979.792.532.513.839 1.216.839 1.958v10.5c0 .742-.307 1.445-.84 1.958a2.854 2.854 0 0 1-1.978.792h-6.364c-.735 0-1.448-.28-1.979-.792A2.717 2.717 0 0 1 9 17.25V15.5a1 1 0 1 1 2 0v1.75c0 .186.076.373.226.517.15.145.363.233.592.233h6.364c.229 0 .441-.088.592-.233A.717.717 0 0 0 19 17.25V6.75a.717.717 0 0 0-.226-.517.855.855 0 0 0-.592-.233h-6.364Zm-4.53 2.303a1 1 0 0 1-.02 1.414l-.805.783H16a1 1 0 1 1 0 2H6.463l.806.783a1 1 0 0 1-1.395 1.434l-2.571-2.5a1 1 0 0 1 0-1.434l2.571-2.5a1 1 0 0 1 1.414.02Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Exit;